// libraries
import type { StateTree } from '@makemydeal/dr-dash-types';

// selectors
import * as tradesSelectors from './../selectors/tradeIns';
import * as connectionSelectors from '../selectors/connectionSelectors';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import type { ITradeIn } from '@makemydeal/dr-platform-types';
import { getTotalTaxReduction, getTradeInItems } from '../selectors/offerRedux';
import { stripUIFields } from './tradeInUIFields';
import type { TradeWithFuelEconomyFields } from '../types/fuelEconomyTypes';

export const createTradesPayload = (state: StateTree): ITradeIn[] => {
    const activeTradeIns = tradesSelectors.getActiveTradeIns(state);
    const connectionId = connectionSelectors.getConnectionId(state);
    const totalTradeTaxReduction = getTotalTaxReduction(state);
    const tradeInItems = getTradeInItems(state);
    const stripUIFieldsEnabled = featureToggleSelectors.isStripTradeInUIFieldsEnabled(state);

    return activeTradeIns.map((tradeIn, index) => {
        const trade = tradeIn as TradeWithFuelEconomyFields;
        const combinedFuelEconomy = trade.combinedFuelEconomy ?? trade.fuelEconomy;
        const {
            cityFuelEconomy: _cityFuelEconomy,
            highwayFuelEconomy: _highwayFuelEconomy,
            fuelEconomy: _fuelEconomy,
            combinedFuelEconomy: _combinedFuelEconomy,
            ...tradePayload
        } = stripUIFields(tradeIn, stripUIFieldsEnabled) as ITradeIn & TradeWithFuelEconomyFields;
        const normalizedFuelEconomy = combinedFuelEconomy != null ? { combinedFuelEconomy, fuelEconomy: combinedFuelEconomy } : {};

        return {
            ...tradePayload,
            ...normalizedFuelEconomy,
            tradeInTaxReduction: tradeInItems[index]?.taxReduction || tradeIn.tradeInTaxReduction,
            totalTradeInTaxReduction: totalTradeTaxReduction || tradeIn.totalTradeInTaxReduction,
            connectionId
        };
    }) as ITradeIn[];
};
